var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    [
      _vm.isLoading
        ? _c("q-spinner-cube", {
            staticClass: "absolute-center",
            attrs: { color: "primary", size: "5em" }
          })
        : _vm.displayedWatchlist
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row q-col-gutter-md q-mb-md" }, [
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  !_vm.displayedWatchlist.searchParams
                    ? _c("h4", [_vm._v(_vm._s(_vm.displayedWatchlist.name))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("ul", [
                    _vm.displayedWatchlist.zohoCustomer &&
                    _vm.user &&
                    !_vm.isPublic
                      ? _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("customer")) +
                              ": " +
                              _vm._s(_vm.displayedWatchlist.zohoCustomer) +
                              " - " +
                              _vm._s(_vm.displayedWatchlist.customerName) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayedWatchlist.totalArea
                      ? _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("resultArea")) +
                              ": " +
                              _vm._s(
                                _vm._f("area")(_vm.displayedWatchlist.totalArea)
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayedWatchlist.totalPrice && !_vm.isPublic
                      ? _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("label.price")) +
                              ": " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.displayedWatchlist.totalPrice
                                )
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-6" }, [
                  _c("div", { staticClass: "row justify-between" }, [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _vm.displayedWatchlist.items.length
                          ? [
                              _c("div", { staticClass: "col" }, [
                                _c("span", { staticClass: "text-overline" }, [
                                  _vm._v(_vm._s(_vm.$t("sorting")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _c(
                                    "q-btn-dropdown",
                                    {
                                      attrs: {
                                        split: "",
                                        color: "primary",
                                        label: _vm.$t(
                                          "button.watchlistSorting." +
                                            _vm.sortingProperty
                                        ),
                                        icon: _vm.sortingIcon,
                                        "no-caps": ""
                                      },
                                      on: { click: _vm.changeSortingDirection }
                                    },
                                    [
                                      _c(
                                        "q-list",
                                        [
                                          _c(
                                            "q-item",
                                            [
                                              _c(
                                                "q-item-section",
                                                {
                                                  directives: [
                                                    {
                                                      name: "close-popup",
                                                      rawName: "v-close-popup"
                                                    }
                                                  ],
                                                  attrs: { clickable: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setSorting(
                                                        "added"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("q-item-label", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("added"))
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "q-item",
                                            [
                                              _c(
                                                "q-item-section",
                                                {
                                                  directives: [
                                                    {
                                                      name: "close-popup",
                                                      rawName: "v-close-popup"
                                                    }
                                                  ],
                                                  attrs: { clickable: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setSorting(
                                                        "logArea"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("q-item-label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("resultArea")
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "q-item",
                                            [
                                              _c(
                                                "q-item-section",
                                                {
                                                  directives: [
                                                    {
                                                      name: "close-popup",
                                                      rawName: "v-close-popup"
                                                    }
                                                  ],
                                                  attrs: { clickable: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setSorting(
                                                        "customerQualityName"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("q-item-label", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("quality"))
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "q-item",
                                            [
                                              _c(
                                                "q-item-section",
                                                {
                                                  directives: [
                                                    {
                                                      name: "close-popup",
                                                      rawName: "v-close-popup"
                                                    }
                                                  ],
                                                  attrs: { clickable: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setSorting(
                                                        "logNo"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("q-item-label", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("logNo"))
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "q-item",
                                            [
                                              _c(
                                                "q-item-section",
                                                {
                                                  directives: [
                                                    {
                                                      name: "close-popup",
                                                      rawName: "v-close-popup"
                                                    }
                                                  ],
                                                  attrs: { clickable: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setSorting(
                                                        "palletNo"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("q-item-label", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("palletNo"))
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column q-mt-md" },
                      [
                        _vm.user || !_vm.displayedWatchlist.dynamic
                          ? _c(
                              "q-btn",
                              {
                                staticClass: "float-right",
                                attrs: {
                                  color: "primary",
                                  icon: "more_vert",
                                  outline: "",
                                  dense: ""
                                }
                              },
                              [
                                _c(
                                  "q-menu",
                                  [
                                    _c(
                                      "q-list",
                                      [
                                        _vm.user && !_vm.isPublic
                                          ? _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-popup",
                                                    rawName: "v-close-popup"
                                                  }
                                                ],
                                                attrs: { clickable: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editWatchlist(
                                                      _vm.displayedWatchlist
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-item-section", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "button.watchlistSettings"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.user && !_vm.isPublic
                                          ? _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-popup",
                                                    rawName: "v-close-popup"
                                                  }
                                                ],
                                                attrs: { clickable: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.share(
                                                      _vm.displayedWatchlist
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-item-section", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.share")
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.displayedWatchlist.searchParams
                                          ? _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-popup",
                                                    rawName: "v-close-popup"
                                                  }
                                                ],
                                                attrs: { clickable: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadWatchlistSummary(
                                                      _vm.displayedWatchlist
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-item-section", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "button.downloadWatchlistSummary"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.user &&
                                        !_vm.isPublic &&
                                        !_vm.displayedWatchlist.searchParams
                                          ? _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-popup",
                                                    rawName: "v-close-popup"
                                                  }
                                                ],
                                                attrs: { clickable: "" },
                                                on: { click: _vm.newVirtualLog }
                                              },
                                              [
                                                _c("q-item-section", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "button.newVirtualLog"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.user && !_vm.isPublic
                                          ? _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-popup",
                                                    rawName: "v-close-popup"
                                                  }
                                                ],
                                                attrs: { clickable: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteWatchlist(
                                                      _vm.displayedWatchlist
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-item-section", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "button.deleteWatchlist"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.user &&
                                        !_vm.isPublic &&
                                        _vm.displayedWatchlist.searchParams
                                          ? _c(
                                              "q-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "close-popup",
                                                    rawName: "v-close-popup"
                                                  }
                                                ],
                                                attrs: { clickable: "" },
                                                on: {
                                                  click:
                                                    _vm.startSearchParamsEdit
                                                }
                                              },
                                              [
                                                _c("q-item-section", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "button.editSearchParams"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              !_vm.displayedWatchlist.dynamic
                ? [
                    _vm.displayedWatchlist.items.length
                      ? _c(
                          "div",
                          { staticClass: "row q-col-gutter-md" },
                          _vm._l(_vm.sortedWatchlistItems, function(item) {
                            return _c("watchlist-item", {
                              key: item.uid,
                              staticClass:
                                "col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3",
                              attrs: { item: item, "is-public": _vm.isPublic }
                            })
                          }),
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "row q-col-gutter-md q-mt-lg justify-center"
                          },
                          [
                            _vm.user && !_vm.isPublic
                              ? _c(
                                  "div",
                                  [
                                    _c("q-btn", {
                                      staticClass: "large-cta-btn",
                                      attrs: {
                                        label: _vm.$t(
                                          "button.newWatchlistAddFromSearch"
                                        ),
                                        color: "accent",
                                        "text-color": "accentText",
                                        size: "xl",
                                        "no-caps": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push({
                                            name: "search"
                                          })
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.user && !_vm.isPublic
                              ? _c(
                                  "div",
                                  [
                                    _c("q-btn", {
                                      staticClass: "large-cta-btn",
                                      attrs: {
                                        label: _vm.$t(
                                          "button.newWatchlistAddFromWatchlist"
                                        ),
                                        color: "accent",
                                        "text-color": "accentText",
                                        size: "xl",
                                        "no-caps": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push({
                                            name: "watchlists"
                                          })
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                  ]
                : [
                    (_vm.displayedWatchlist.searchParams ||
                      _vm.watchlistSearchParams) &&
                    !_vm.selectingParamsFromWatchlist
                      ? _c("log-search", {
                          attrs: {
                            "is-dynamic-watchlist": true,
                            "is-public": _vm.isPublic
                          }
                        })
                      : _c(
                          "div",
                          {
                            staticClass:
                              "row q-col-gutter-md q-mt-lg justify-center"
                          },
                          [
                            !_vm.selectingParamsFromWatchlist
                              ? [
                                  _vm.user && !_vm.isPublic
                                    ? _c(
                                        "div",
                                        [
                                          _c("q-btn", {
                                            staticClass: "large-cta-btn",
                                            attrs: {
                                              label: _vm.$t(
                                                "button.newWatchlistSearchParametersFromSearch"
                                              ),
                                              color: "accent",
                                              "text-color": "accentText",
                                              size: "xl",
                                              "no-caps": ""
                                            },
                                            on: {
                                              click: _vm.startSearchParamsEdit
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.user && !_vm.isPublic
                                    ? _c(
                                        "div",
                                        [
                                          _c("q-btn", {
                                            staticClass: "large-cta-btn",
                                            attrs: {
                                              label: _vm.$t(
                                                "button.newWatchlistSearchParametersFromWatchlist"
                                              ),
                                              color: "accent",
                                              "text-color": "accentText",
                                              size: "xl",
                                              "no-caps": ""
                                            },
                                            on: {
                                              click: _vm.selectSearchParams
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c("watchlists", {
                                    attrs: { emit: "", "parameter-search": "" },
                                    on: {
                                      "select-watchlist": _vm.setSearchParams
                                    }
                                  })
                                ]
                          ],
                          2
                        )
                  ]
            ],
            2
          )
        : _c("div", [
            _c("h2", { staticClass: "text-center" }, [
              _vm._v(_vm._s(_vm.$t("watchlistUnavailable")))
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }